const normalizeUrl = value => (value || '').replace(/\/+$/, '');

export const defaultApiUrl = normalizeUrl(process.env.VUE_APP_BASE_SERVER);
export const homologApiUrl = 'https://dev.lecard.app.br';
export const alternativeApiUrl = 'https://api-2.lecard.app.br';
export const defaultSocketBaseUrl = normalizeUrl(process.env.VUE_APP_BASE_SOCKET);
export const homologSocketBaseUrl = 'https://hhh-lecard-socket-server-5p6ki.ondigitalocean.app';

export const socketBaseUrl = getActiveSocketUrl();
export const entregadoresSocketUrl = `${socketBaseUrl}/entregadores`;
export const trackingLocationUrl = `${socketBaseUrl}/api/tracking/location`;

export function getActiveApiUrl() {
  return normalizeUrl(localStorage.getItem('base_server') || defaultApiUrl);
}

export function getActiveSocketUrl() {
  return getActiveApiUrl() === homologApiUrl
    ? homologSocketBaseUrl
    : defaultSocketBaseUrl;
}
